/**
 * Created by alex.shmaltsuev on 2016-03-31.
 */
import initialState from '../store/initialstate'
import Constants from '../constants/auth'

export default (state = initialState().auth, action = null) => {
    switch(action.type){
        case Constants.LOGIN:
            return state.set('logedIn',true);
        case Constants.LOGOUT:
            return state.set('logedIn',false);
        case Constants.KEEP_ALIVE:
            return state.set('keepAliveInterval',true);
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./reducers/auth.js